import { toNumber } from 'lodash';
import { MutationTree } from 'vuex';

export const state = () => ({
  id: null,
  readonly: false,
  query: {
    where: {},
    include: ['dna-trait', 'rpx-dna-trait'],
    limit: 10,
    offset: 0,
    sort: '-isActive, position'
  },
  table: {
    footer: {
      'items-per-page-options': [10, 25, 50, 100],
      'show-current-page': true,
      'show-first-last-page': true
    },
    filter: {
      panels: [],
      status: [],
      keyword: ''
    },
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: ['isActive', 'position'],
      sortDesc: [false, true],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: true
    }
  }
});

export type DNA360InteractomeState = ReturnType<typeof state>;

export const mutations: MutationTree<DNA360InteractomeState> = {
  changeId: (state, id) => (state.id = id),
  changeReadonly: (state, readonly) => (state.readonly = readonly),
  changeQuery: (state, query) => Object.assign(state.query, query),
  changeTableFilter: (state, filter) => {
    Object.assign(state.table, { filter });
    Object.assign(state.query, {
      where: {
        dnaTraitId: /\d/i.test(filter.keyword)
          ? toNumber(filter.keyword.replace(/\D/g, ''))
          : null,
        keyword: /\d/i.test(filter.keyword)
          ? null
          : filter.keyword
            ? filter.keyword
            : null
      }
    });
  },
  changeTableOptions: (state, options) => {
    Object.assign(state.table, { options });
    Object.assign(state.query, {
      // sort: set({}, options.sortBy[0], options.sortDesc[0] ? 'DESC' : 'ASC'),
      limit: options.itemsPerPage,
      offset: (options.page - 1) * options.itemsPerPage
    });
  }
};
